/**
 * Hero Slider - Swiper Initialization
 * Custom web component for Swiper slider functionality
 */

class HeroSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sectionId = this.dataset.sectionId;
  }
  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.hero-swiper');
    if (!swiperContainer) return;

    const swiperConfig = {
      loop: false,
      speed: 600,
      effect: 'slide',
      direction: 'horizontal',
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('.hero-slider__nav--next'),
        prevEl: this.querySelector('.hero-slider__nav--prev'),
      },
      pagination: {
        el: this.querySelector('.hero-slider__pagination'),
        type: 'fraction',
        formatFractionCurrent: (number) => number,
        formatFractionTotal: (number) => number,
        renderFraction: (currentClass, totalClass) => {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        }
      },
      on: {
        init: () => {
          this.classList.add('swiper-initialized');
        }
      }
    };

    const doInit = () => {
      if (typeof Swiper === 'undefined') return;
      this.swiper = new Swiper(swiperContainer, swiperConfig);
    };

    // Wait for fonts to load so second slide heading doesn't show fallback font (FOUT)
    const fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    fontsReady.then(() => {
      if (typeof Swiper !== 'undefined') {
        doInit();
      } else {
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            doInit();
          }
        }, 100);
      }
    });
  }
}

// Define custom element
if (!customElements.get('hero-slider')) {
  customElements.define('hero-slider', HeroSlider);
}

// Fallback initialization for non-web-component usage
document.addEventListener('DOMContentLoaded', function() {
  const heroSliders = document.querySelectorAll('.hero-slider:not(hero-slider)');
  
  heroSliders.forEach(slider => {
    const initSlider = () => {
      const swiperContainer = slider.querySelector('.hero-swiper');
      if (!swiperContainer || swiperContainer.swiper) return;

      const config = {
        loop: false,
        speed: 600,
        effect: 'slide',
        direction: 'horizontal',
        slidesPerView: 1,
        navigation: {
          nextEl: slider.querySelector('.hero-slider__nav--next'),
          prevEl: slider.querySelector('.hero-slider__nav--prev'),
        },
        pagination: {
          el: slider.querySelector('.hero-slider__pagination'),
          type: 'fraction',
          formatFractionCurrent: (number) => number,
          formatFractionTotal: (number) => number,
          renderFraction: (currentClass, totalClass) => {
            return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
          }
        }
      };

      new Swiper(swiperContainer, config);
    };

    if (typeof Swiper !== 'undefined') {
      initSlider();
    } else {
      const checkSwiper = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(checkSwiper);
          initSlider();
        }
      }, 40000);
    }
  });
});




// Shopify Theme Editor support
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const slider = event.target.querySelector('.hero-slider');
    if (slider) {
      const swiperContainer = slider.querySelector('.hero-swiper');
      if (swiperContainer && swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
      }
      
      setTimeout(() => {
        const heroSliderElement = event.target.querySelector('hero-slider');
        if (heroSliderElement && heroSliderElement.initSwiper) {
          heroSliderElement.initSwiper();
        }
      }, 100);
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const slider = event.target.closest('.hero-slider');
    if (slider) {
      const swiperContainer = slider.querySelector('.hero-swiper');
      if (swiperContainer && swiperContainer.swiper) {
        const slideIndex = [...event.target.parentElement.children].indexOf(event.target);
        swiperContainer.swiper.slideToLoop(slideIndex);
      }
    }
  });
}
